import { useToggle } from 'admin';
import { Main } from 'features';
import type { ReactNode } from 'react';
import { Box, useBreakpoint } from 'ui';

import { InternalHeader } from '../InternalHeader/InternalHeader';
import { InternalSidebar } from '../InternalSidebar/InternalSidebar';

export const Layout = ({ children }: { children: ReactNode }) => {
  const { isMobile } = useBreakpoint();
  const { open, close, isOpen } = useToggle(isMobile ? false : true);

  return (
    <Box display="flex">
      <InternalHeader
        onMenuClick={() => {
          isOpen ? close() : open();
        }}
      />
      <InternalSidebar isOpen={isOpen} onClose={close} />
      <Main isOpen={isOpen}>{children}</Main>
    </Box>
  );
};
